var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsufficient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 200,
    viewBox: "0 0 188 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_11622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_589_11622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 172,
    height: 258
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 0H8V258H180V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_589_11622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_589_11622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -174,
    y: -24,
    width: 534,
    height: 288
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-173.557 -23.0537H359.643V263.986H-173.557V-23.0537Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_589_11622)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0443 43.2339C135.669 43.2339 170.276 77.8415 170.276 120.466C170.276 163.09 135.669 197.697 93.0443 197.697C50.4201 197.697 15.8125 163.09 15.8125 120.466C15.8125 77.8415 50.4201 43.2339 93.0443 43.2339Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_589_11622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -72,
    y: -51,
    width: 636,
    height: 416
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-71.502 52.2842L508.733 -50.0269L563.81 262.333L-16.4245 364.644L-71.502 52.2842Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_589_11622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.545 72.0837L175.178 143.731C176.437 150.867 173.206 157.411 167.969 158.334L36.0668 181.592C30.8294 182.516 25.5554 177.472 24.2971 170.335L11.6637 98.6881C10.4054 91.5519 13.6361 85.008 18.8735 84.0845L150.775 60.8267C156.013 59.9032 161.287 64.9474 162.545 72.0837Z",
    fill: "#D62B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3991 110.697L52.5214 122.733C52.8972 124.864 51.4717 126.9 49.3402 127.276L37.3044 129.398C35.1729 129.774 33.1371 128.348 32.7612 126.217L30.639 114.181C30.2632 112.049 31.6887 110.014 33.8202 109.638L45.8559 107.516C47.9875 107.14 50.0233 108.565 50.3991 110.697Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.724 137.485C61.9716 138.889 61.0328 140.229 59.6289 140.477L37.3557 144.404C35.9518 144.652 34.6111 143.713 34.3635 142.309C34.116 140.905 35.0548 139.565 36.4586 139.317L58.7319 135.39C60.1357 135.142 61.4765 136.081 61.724 137.485Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5697 131.517C95.8173 132.92 94.8785 134.261 93.4746 134.509L71.2014 138.436C69.7975 138.684 68.4568 137.745 68.2092 136.341C67.9617 134.937 68.9005 133.596 70.3043 133.349L92.5776 129.421C93.9814 129.174 95.3222 130.113 95.5697 131.517Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.417 125.548C129.665 126.952 128.726 128.293 127.322 128.54L105.049 132.468C103.645 132.715 102.304 131.777 102.057 130.373C101.809 128.969 102.748 127.628 104.152 127.381L126.425 123.453C127.829 123.206 129.17 124.144 129.417 125.548Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.264 119.581C163.512 120.984 162.573 122.325 161.169 122.573L138.896 126.5C137.492 126.748 136.151 125.809 135.904 124.405C135.656 123.001 136.595 121.66 137.999 121.413L160.272 117.485C161.676 117.238 163.017 118.177 163.264 119.581Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.96 148.24C119.208 149.644 118.269 150.985 116.865 151.232L94.592 155.16C93.1882 155.407 91.8474 154.468 91.5999 153.065C91.3523 151.661 92.2912 150.32 93.695 150.072L115.968 146.145C117.372 145.898 118.713 146.836 118.96 148.24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6984 153.601C85.946 155.005 84.1959 156.489 81.7929 156.913L43.6661 163.635C41.2631 164.059 39.1111 163.263 38.8635 161.86C38.616 160.456 40.3661 158.972 42.7691 158.548L80.8958 151.825C83.2989 151.402 85.4509 152.197 85.6984 153.601Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.611 135.204C146.181 134.398 150.546 137.454 151.352 142.025C152.158 146.596 149.101 150.961 144.531 151.767C139.96 152.573 135.595 149.516 134.789 144.945C133.983 140.375 137.04 136.01 141.611 135.204Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.363 132.955C158.934 132.149 163.299 135.205 164.105 139.776C164.911 144.346 161.854 148.712 157.284 149.518C152.713 150.324 148.348 147.267 147.542 142.696C146.736 138.126 149.793 133.761 154.363 132.955Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6989 106.415C56.6989 106.415 59.479 117.238 70.6055 115.276C81.732 113.314 79.7908 101.598 79.7908 101.598",
    stroke: "#010101",
    strokeWidth: 3.42221,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.822 99.7694C102.822 99.7694 105.602 110.592 116.729 108.63C127.855 106.668 125.914 94.9517 125.914 94.9517",
    stroke: "#010101",
    strokeWidth: 3.42221,
    strokeLinecap: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.931 138.324C110.931 138.324 105.357 129.662 95.8689 130.996C86.3813 132.329 83.25 142.76 83.25 142.76",
    stroke: "#010101",
    strokeWidth: 4.06286,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_11622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 258,
    fill: "white",
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsufficient);
export default __webpack_public_path__ + "static/media/insufficient.db2a9e9db638a228744c260efde47fb0.svg";
export { ForwardRef as ReactComponent };